const secondary = {
    social_bind_with: 'حساب کاربری دارید؟ برای متصل کردن {{methods, list(type: disjunction;)}} به هویت اجتماعی خود، وارد حساب خود شوید.',
};
export default Object.freeze(secondary);
